/* tslint:disable max-line-length */

export enum RoleKeys {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  ACCOUNTING = 'ACCOUNTING',
  OWNER = 'OWNER',
  STAFF = 'STAFF',
  GUEST = 'GUEST',
  READ_ONLY = 'READ-ONLY',
}

export const readOnlyPermission = 'readOnly'

export const roles = {
  [RoleKeys.ADMIN]: [
    'canSeeAppStore',
    'canMigrateToSympl',
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canDeleteAccount',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeICalURL',
    'canSeeHold',
    'canSeeTasks',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeBilling',
    'canSeeGuests',
    'canSeeRates',
    'canSeeDataFeeds',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canEditUser',
    'canSeeIntegrations',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canAddInquiry',
    'canEditInquiry',
    'canAddHold',
    'canEditHold',
    'canEditRental',
    'canEditGuest',
    'canEditNotes',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeCalendarActions',
    'canSeeDashboard',
    'canAddTasks',
    'canEditTasks',
    'canDeleteTasks',
    'canSeeGuestContacts',
    'canSeeReviews',
  ],
  [RoleKeys.MANAGER]: [
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeICalURL',
    'canSeeHold',
    'canSeeTasks',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeGuests',
    'canSeeRates',
    'canSeeDataFeeds',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canSeeIntegrations',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canAddInquiry',
    'canEditInquiry',
    'canAddHold',
    'canEditHold',
    'canEditRental',
    'canEditGuest',
    'canEditNotes',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeCalendarActions',
    'canSeeDashboard',
    'canAddTasks',
    'canEditTasks',
    'canDeleteTasks',
    'canSeeGuestContacts',
    'canSeeReviews',
  ],
  [RoleKeys.READ_ONLY]: [
    readOnlyPermission,
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeICalURL',
    'canSeeHold',
    'canSeeTasks',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeGuests',
    'canSeeRates',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canSeeIntegrations',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canEditInquiry',
    'canAddHold',
    'canEditHold',
    'canEditRental',
    'canEditGuest',
    'canEditNotes',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeDashboard',
    'canDeleteTasks',
    'canSeeGuestContacts',
    'canSeeReviews',
  ],
  [RoleKeys.ACCOUNTING]: ['canSeeReports'],
  [RoleKeys.OWNER]: ['canSeeCalendar', 'canSeeMultiCalendar', 'canSeeStandardCalendar', 'canEditHold', 'canAddHold'],
  [RoleKeys.STAFF]: [
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeHold',
    'canSeeAllRentals',
    'canSeeTasks',
    'canSeeGuestContacts',
  ],
  [RoleKeys.GUEST]: [],
}
